import { actionTypes } from '../actions/actionTypes';
import { fromJS } from 'immutable';

export const routeReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case actionTypes.CREATE_ORGANIZER_LINK: { 
      return state.set('edit_url', payload);
    }
    case actionTypes.UPDATE_NEXT_MATERIAL: {
      const next_material_data = {
        "id": payload.actual_material.id,
        "name": payload.actual_material.title,
        "course_title": payload.title,
        "badge_url": payload.badge_url,
        "thumbnail": payload.actual_material.thumbnail,
        "material_url": payload.actual_material.url,
      }
      return state.setIn(['material_data'], fromJS(next_material_data));
    }
    case actionTypes.UPDATE_COURSE_PROGRESS: {
      const stepsArray = state.get('steps').map((step) => {
        const coursesArray = step.get('courses').map((item) => {
          const courseId = item.get('id');
          return {
            ...item.toJS(),
            ...payload[courseId]
          };
        });
        return {
          title: step.get('title'),
          level: step.get('level'),
          courses: coursesArray,
        }
      });
      return state.setIn(['steps'], stepsArray);
    }
    default:
      return state;
  }
};
